import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';

export const Row = styled('div', { label: 'Row' })`
    padding: 5px 0;
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ContentContainer = styled('div', { label: 'ContentContainer' })`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
`;

export const PromoCode = styled('div', { label: 'PromoCode' })`
    color: ${mainColors.main.primary};
    font-size: 14px;
    font-weight: ${fontWeight.bold};
`;

export const UsageInfo = styled('div', { label: 'UsageInfo' })`
    color: ${mainColors.main.primary};
    font-size: 12px;
`;

export const PromoInfoWrapper = styled('div', { label: 'PromoInfoWrapper' })`
    display: flex;
    flex-direction: column;
`;
